import { PlantListContainer } from '@containers'

const PlantListPage = () => {
  return <PlantListContainer />
}

export default PlantListPage
